import { get } from 'js/lib/user';

import localStorageEx from 'bundles/common/utils/localStorageEx';
import { RECENTLY_VIEWED_LOCAL_STORAGE_NAME } from 'bundles/search-common/constants';
import { getItemsListFromLocalStorageByKeyAndTrimOutdated } from 'bundles/search-common/utils/SearchUtils';

export const INFERRED_ROLE_STORAGE_KEY = 'inferred_role_banner_dismissed';

/**
 * @description show inferred role banner if user has viewed more than 3 pathway related items
 */
const showInferredRole = () => {
  const userId = get().id;

  const recentlyViewed = getItemsListFromLocalStorageByKeyAndTrimOutdated(RECENTLY_VIEWED_LOCAL_STORAGE_NAME);

  const pathwayRelatedItems = recentlyViewed.filter(
    (item) => item.productType === 'Career Role' || item.isPathwayProduct
  );

  return (
    !localStorageEx.getItem(`${INFERRED_ROLE_STORAGE_KEY}-${userId}`, JSON.parse, false) &&
    pathwayRelatedItems.length > 3
  );
};

export default showInferredRole;
